import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { CandidateStatusType } from './candidate-status-type.interface';

export class CandidateStatusTypeService {
   async getCandidateStatusTypes() {
      const response = await http.get<ApiResource<Array<CandidateStatusType>>>(`/candidate-status-types`, {
         ...cacheFirstConfig,
      });
      return response.data;
   }

   async getCandidateStatusType() {
      throw Error('Method not implemented');
   }

   async postCandidateStatusType() {
      throw Error('Method not implemented');
   }

   async putCandidateStatusType() {
      throw Error('Method not implemented');
   }

   async deleteCandidateStatusType() {
      throw Error('Method not implemented');
   }
}
